/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMousePointer(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.985 2.985a.75.75 0 01.818-.162l16.97 7.07a.75.75 0 01-.047 1.402l-6.248 2.122 5.567 5.568a.75.75 0 01-1.06 1.06l-5.568-5.567-2.122 6.248a.75.75 0 01-1.402.047l-7.07-16.97a.75.75 0 01.162-.818zm1.923 1.923l5.606 13.455 1.87-5.51a.75.75 0 01.47-.468l5.51-1.871L4.907 4.908z'
      />
    </svg>
  );
}

export default SvgMousePointer;
